import React, { useState, useEffect, useMemo } from 'react'

import PartnerItem from './PartnerItem'
import ProjectDesignation from './ProjectDesignation'

const useBeneficiarySelect = ({
  i18n, commonInputProps, partner_item, partner_items, goal_partner_item,
  disable_donation_split,
}) => {
  const [ partnerItemError, setPartnerItemError ] = useState(null)
  const [ partnerItem, setPartnerItem ] = useState(() =>
    partner_items.length == 1 ? partner_items[0] : partner_item
  )

  const [ projectError, setProjectError ] = useState(null)
  const preselectedProject = useMemo(() =>
    goal_partner_item.projects.find(project => project.preselected) || (
      goal_partner_item.projects.length == 1
        ? goal_partner_item.projects[0]
        : null
    )
  , [ goal_partner_item.projects ])
  const [ projectId, setProjectId ] = useState(() => preselectedProject?.id || '')

  const validate = () => {
    const isPartnerItemInvalid =
      disable_donation_split && partnerItem.beneficiary.id == '_multiple'
    setPartnerItemError(isPartnerItemInvalid ? i18n.t('errors.blank') : null)

    const isProjectInvalid = goal_partner_item.projects.length && projectId == ''
    setProjectError(isProjectInvalid ? i18n.t('errors.blank') : null)

    return !isPartnerItemInvalid && !isProjectInvalid
  }

  useEffect(() => { setPartnerItemError(null) }, [ partnerItem.external_id ])
  useEffect(() => { setProjectError(null) }, [ projectId ])

  // The two flags Amount gates its impact line on. Both describe how the
  // fundraiser is configured rather than what the donor has currently
  // picked, which is what keeps them in step with the editor's gate in
  // PWCAmounts — see the fuller note in v7's useBeneficiarySelect.
  // multiOrg is not `beneficiary.id == '_multiple'` (that's just the
  // "split among all" option), and multiProject is not `projectId`
  // (a sole designation is preselected above and never shown).
  const multiOrg = partner_items.length > 1
  const multiProject = goal_partner_item.projects.length > 1

  const render = () => {
    if (partner_items.length) return (
      <PartnerItem
        i18n={i18n}
        error={partnerItemError}
        commonInputProps={commonInputProps}
        partnerItem={partnerItem}
        setPartnerItem={setPartnerItem}
        partner_items={partner_items}
        goal_partner_item={goal_partner_item}
        disable_donation_split={disable_donation_split}
      />
    )

    if (multiProject) return (
      <ProjectDesignation
        i18n={i18n}
        error={projectError}
        commonInputProps={commonInputProps}
        projectId={projectId}
        setProjectId={setProjectId}
        projects={goal_partner_item.projects}
        prompt={!preselectedProject}
      />
    )

    return null
  }

  return { partnerItem, projectId, multiOrg, multiProject, validate, render }
}

export default useBeneficiarySelect
